import React from 'react'
import { IndexLink, Link } from 'react-router'
import PropTypes from 'prop-types'
import { Layout, Menu, SubMenu, Icon } from 'antd'

import './PublicLayout.scss'

export const PublicLayout = ({ children, }) => (
  <Layout className="public-layout">
    { children }

    <span className="version">v { __VERSION__ }</span>
  </Layout>
)

PublicLayout.propTypes = {
  children: PropTypes.element,
}

export default PublicLayout



// WEBPACK FOOTER //
// ./src/layouts/PublicLayout/PublicLayout.jsx